import { render, staticRenderFns } from "./annotation.vue?vue&type=template&id=e6b39ef0"
import script from "./annotation.ts?vue&type=script&lang=ts&external"
export * from "./annotation.ts?vue&type=script&lang=ts&external"
import style0 from "./annotation.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports